import React, { FC } from 'react';
import { useUserContext } from '@blocs.auth';
import { Trans } from '@blocs.i18n';
import { gqlCountryEnum as countries } from '@minecraft.graphql-types';
import { BodyTextSmall, Link } from '@minecraft.atoms';

const TermsLink: FC = ({ children }) => {
  const { myAccount } = useUserContext();
  const policy =
    myAccount?.country?.code === countries.AU
      ? 'https://corp.castingnetworks.com/au/terms-of-use/#18'
      : 'https://corp.castingnetworks.com/terms-of-use';

  return (
    <Link target="_blank" to={policy}>
      {children}
    </Link>
  );
};

const AuthorizeMessage = () => {
  return (
    <BodyTextSmall>
      <Trans i18nKey="common:membership.authorizeMessage" components={[<TermsLink />]} />
    </BodyTextSmall>
  );
};

export default AuthorizeMessage;
